/* global Stimulus, Controller */
import "./leaflet.scss";
import { Map, TileLayer, DivIcon, Marker } from "leaflet/dist/leaflet-src.esm";
import { useDebounce } from "stimulus-use";

Stimulus.register(
  "leaflet",
  class extends Controller {
    static targets = ["map", "item"];

    static debounces = ["refresh"];

    static values = {
      zoom: { type: Number, default: 2 },
      latitude: { type: Number, default: 60 },
      longitude: { type: Number, default: 10 },
    };

    connect() {
      useDebounce(this, { wait: 100 });
      this.mapTarget.style.height = "500px";
      this.startUp();
    }

    disconnect() {
      this.tearDown();
    }

    refresh() {
      this.tearDown();
      this.startUp();
    }

    startUp() {
      this.initMap();
      this.coordinates();
    }

    tearDown() {
      this.map.remove();
    }

    initMap() {
      this.map = new Map(this.mapTarget, {
        center: [this.latitudeValue, this.longitudeValue],
        zoom: this.zoomValue,
        layers: [this.osm],
      });
    }

    coordinates() {
      const windowWidth = window.innerWidth;
      const popupWidth = windowWidth < 400 ? (300 / 100) * 80 : 300;
      this.itemTargets.forEach((el) => {
        if (window.getComputedStyle(el).display !== "none") {
          new Marker([el.dataset.latitude, el.dataset.longitude], {
            icon: this.svgIcon,
          })
            .bindPopup(el.dataset.popupContent, {
              className: "leaflet-custom-popup",
              maxWidth: popupWidth,
            })
            .addTo(this.map);
        }
      });
    }

    osm = new TileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution: "© OpenStreetMap",
    });

    svgIcon = new DivIcon({
      html: `
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742zM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" clip-rule="evenodd"/></svg>
      `,
      className: "",
      iconSize: [24, 24],
      iconAnchor: [12, 24],
    });
  }
);
